import Cookies from 'js-cookie';
import actionTypes from './actionTypes';

const initialState = {
  token: Cookies.get("token"),
  loading: false,
  editMode: false,
  showModal: false,
  errors: {},
  message: null,

  partner: null,
  partners: [],
  file: null,
  status: 'public',
  link: null,
  title: '',

};


export default function reducer(state=initialState, action) {
  switch (action.type) {

    case actionTypes.PARTNERS_SET_INITIAL_PARTNER:
      const emptyPartner = {
        editMode: false,
        partner: null,
        file: null,
        status: 'public',
        link: null,
        title: '',
      };
      return {...state, ...emptyPartner};

    case actionTypes.LOADING:
      return {...state, loading: action.loading};

    case actionTypes.SET_PARTNERS:
      return {...state, partners: action.partners};

    case actionTypes.PARTNER_SHOW_FORM:
      return {...state, showModal: true};

    case actionTypes.PARTNERS_HIDE_FORM:
      return {...state, showModal: false};

    case actionTypes.SHOW_MESSAGE:
      return {...state, message: action.message};

    case actionTypes.PARTNERS_SET_FILE:
      return {...state, loading: false, file: action.file};

    case actionTypes.PARTNERS_CHANGE_INPUT:
      return {...state, [action.name]: action.value};

    case actionTypes.PARTNERS_SET_ERRORS:
      return {...state, errors: action.errors};

    case actionTypes.PARTNERS_SET_PARTNER:
      return {...state, ...action.partner, partner: action.partner, editMode: true};

    default:
      return state;
  }
}
